import { createStore, combineReducers, applyMiddleware, compose } from "redux";

//MIDDLEWARE
import { checkoutStoreMiddleware } from "../middlewares/checkoutStore";
import { notifyAnalytics } from "../middlewares/notifyAnalytics";
import { apiMiddleware } from "./api";
// import logger from "redux-logger";

// REDUCERS
import { checkoutStoreReducer } from "../reducers/checkoutStore";
import { uiReducer } from "./ui";

const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  : compose;

const middlewaresList = [checkoutStoreMiddleware, notifyAnalytics];
// if (process.env.NODE_ENV !== "production") {
//   middlewaresList.push(logger);
// }

const initialState = {
  ui: {
    isLoading: true,
    stripeIntentLoading: false,
  },
};
const reducers = {
  checkoutStore: checkoutStoreReducer,
};

const store = createStore(
  combineReducers({ ui: uiReducer, ...reducers }),
  initialState,
  compose(
    applyMiddleware(...[...(middlewaresList || []), apiMiddleware]),
    devTools,
  ),
);

export default store;
